import { forwardRef, useImperativeHandle, useState } from 'react'

const Modal = forwardRef(({
    title,
    showInfoButton = false,
    onInfoClick,
    children,
    footer,
    size = 'md'
}, ref) => {
    const [show, setShow] = useState(false)

    useImperativeHandle(ref, () => ({
        open() {
            setShow(true)
        },
        close() {
            setShow(false)
        },
        isOpen() {
            return show
        }
    }))

    const handleClose = () => {
        setShow(false)
    }

    if (!show) return null

    const sizeClass = size === 'sm' ? 'modal-sm' :
        size === 'lg' ? 'modal-lg' :
            size === 'xl' ? 'modal-xl' : ''

    return (
        <>
            <div className="modal fade show d-block" tabIndex="-1">
                <div className={`modal-dialog modal-dialog-centered ${sizeClass}`}>
                    <div className="modal-content" style={{ maxHeight: '90vh', display: 'flex', flexDirection: 'column' }}>
                        <div className="modal-header bg-primary text-white flex-shrink-0">
                            <h5 className="modal-title">{title}</h5>
                            <div className="d-flex align-items-center gap-2">
                                {showInfoButton && onInfoClick && (
                                    <button
                                        type="button"
                                        className="btn btn-link p-0 text-white"
                                        onClick={onInfoClick}
                                        style={{ fontSize: '14px', textDecoration: 'none' }}
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                            <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
                                        </svg>
                                    </button>
                                )}
                                <button
                                    type="button"
                                    className="btn-close btn-close-white"
                                    onClick={handleClose}
                                ></button>
                            </div>
                        </div>

                        <div className="modal-body" style={{ overflowY: 'auto', flex: '1 1 auto' }}>
                            {children}
                        </div>

                        {footer && (
                            <div className="modal-footer flex-shrink-0">
                                {footer}
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <div className="modal-backdrop fade show"></div>
        </>
    )
})

export default Modal